import { useRecoilValue } from 'recoil';
import { Color } from '../enums/Color.enum';
import { ProductHandle } from '../enums/ProductHandle.enum';
import { ViewVariant } from '../models/ShopifyVariant.model';
import { ViewProduct } from '../models/ViewProduct.model';
import { environmentContextState } from '../recoil/atoms';

const getDiscountByProduct = (product: ViewProduct, timedSaleActive: boolean, timedSaleDiscounts: { [handle in ProductHandle]: number }) => {
  return timedSaleActive ? timedSaleDiscounts[product.handle] : 0;
};
const getDiscountByProductAndColor = (
  product: ViewProduct,
  color: Color,
  warehouseSaleSKUs: string[],
  warehouseSaleEnabled: boolean,
  warehouseDiscountPercentage: number,
  timedSaleActive: boolean,
  timedSaleDiscounts: { [handle in ProductHandle]: number },
) => {
  // If no variant is selected, but a color is provided, see if there is a warehouse sale for the first variant of that color
  // and use the warehouse sale price
  const selectedWarehouseSaleVariant = product.variants.find((v) => warehouseSaleEnabled && warehouseSaleSKUs.includes(v.sku) && v.color === color);
  return selectedWarehouseSaleVariant ? warehouseDiscountPercentage : getDiscountByProduct(product, timedSaleActive, timedSaleDiscounts);
};
const getDiscountByVariant = (
  product: ViewProduct,
  variant: ViewVariant,
  warehouseSaleSKUs: string[],
  warehouseSaleEnabled: boolean,
  warehouseDiscountPercentage: number,
  timedSaleActive: boolean,
  timedSaleDiscounts: { [handle in ProductHandle]: number },
) => {
  const selectedWarehouseSaleVariant = product.variants.find(
    (v) => warehouseSaleEnabled && warehouseSaleSKUs.includes(v.sku) && v.color === variant.color && v.size === variant.size,
  );
  return selectedWarehouseSaleVariant ? warehouseDiscountPercentage : getDiscountByProduct(product, timedSaleActive, timedSaleDiscounts);
};

export const useProductDiscountPercent = (product: ViewProduct, variant?: ViewVariant, color?: Color): number => {
  const { warehouseSaleSKUs, warehouseDiscountPercentage, warehouseSaleEnabled, timedSaleActive, timedSaleDiscounts } = useRecoilValue(environmentContextState);

  if (!variant) {
    if (!color) {
      return getDiscountByProduct(product, timedSaleActive, timedSaleDiscounts);
    }

    return getDiscountByProductAndColor(
      product,
      color,
      warehouseSaleSKUs,
      warehouseSaleEnabled,
      warehouseDiscountPercentage,
      timedSaleActive,
      timedSaleDiscounts,
    );
  }

  if (product.handle === ProductHandle.EGiftCard) {
    return 0;
  }

  return getDiscountByVariant(product, variant, warehouseSaleSKUs, warehouseSaleEnabled, warehouseDiscountPercentage, timedSaleActive, timedSaleDiscounts);
};
